const en_mitra_list = {
    "": "Partner List",

    product: {
        btn_share: "share",
        btn_hide: "hide",
        btn_share_all: "share all",
        btn_hide_all: "hide all",
        search: "Search Product Name / SKU",
        look: "View Partner Products",
        look_share: "View Shared Products ( {{count}} )",
    },

    tag: {
        add: "add tag",
        edit: "edit partner tag",
        name: "tag name",
    },

    error: {
        tag: "Tag is required",
        create_tag: "Failed to create tag",
        create_own_product_share: "Failed to share product",
        create_own_product_hide: "Failed to hide product",
    },

    success: {
        create_tag: "Tag created successfully",
        create_own_product_share: "Product shared successfully",
        create_own_product_hide: "Product hidden successfully",
    },
}

export default en_mitra_list;